export interface UserDevice {
  id: number;
  appVersion: string;
  model: string;
  osName: string;
  osVersion: string;
  status: number;
  userAgent: string;
  userId: number;
  vendor: number;
  createAt: Date;
  updatedAt: Date;
}

export interface UserDevices {
  userDevices: UserDevice[];
}
export enum UserDeviceStatus {
  BINDING,
  UNBIND,
}

export enum UserContactRecordType {
  WECHAT,
  PHONE_CALL,
}

export enum UserContactRecordIntent {
  VERY_POSITIVE,
  POSITIVE,
  NEGATIVE,
  NO_RESPONSE,
}



// WEBPACK FOOTER //
// ./src/screens/user/type.ts